/**
 * SKU API functions
 * 
 * Provides API calls for SKU-related operations.
 * Requirements: 3.3, 3.4, 3.5
 */

import { getProtectedClient } from './client';

export interface SKUOptionsResponse {
  prefixes: string[];
  brands: string[];
  separator: string;
  numberWidth: number;
}

export interface GenerateSKUResponse {
  sku: string;
  prefix: string;
  brand: string;
  number: number;
}

export interface CheckInternalSKUResponse {
  isUnique: boolean;
  existingProductId?: number;
  existingProductName?: string;
}

/**
 * Fetch SKU options (prefixes, brands, separator) from the API
 */
export async function fetchSKUOptions(): Promise<SKUOptionsResponse> {
  const client = getProtectedClient();
  const response = await client.get<{ success: boolean; data: SKUOptionsResponse }>('/sku/options');
  return response.data.data;
}

/**
 * Generate the next available SKU for a given prefix and brand
 */
export async function generateSKU(prefix: string, brand: string): Promise<GenerateSKUResponse> {
  const client = getProtectedClient();
  const response = await client.post<{ success: boolean; data: GenerateSKUResponse }>('/sku/generate', {
    prefix,
    brand,
  });
  return response.data.data;
}

/**
 * Check if an internal SKU is unique
 */
export async function checkInternalSKU(internalSku: string): Promise<CheckInternalSKUResponse> {
  const client = getProtectedClient();
  const response = await client.post<{ success: boolean; data: CheckInternalSKUResponse }>('/sku/check-internal', {
    internal_sku: internalSku,
  });
  return response.data.data;
}
